// extracted by mini-css-extract-plugin
export var errorContainer = "_404-module--errorContainer--8ArMz";
export var errorOops = "_404-module--errorOops--HAR9D";
export var errorPage = "_404-module--errorPage--Gv2sC";
export var errorPageCta = "_404-module--errorPageCta--Edl+6";
export var errorReason = "_404-module--errorReason--PKP9f";
export var errorTexts = "_404-module--errorTexts---h6YG";